var _defs, _style, _use, _use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    width: 10,
    height: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKAQMAAAC3/F3+AAAAAXNSR0IB2cksfwAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAALSURBVHicY2DABwAAHgAB9v3plgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    id: "img2",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAMAAAC67D+PAAAAAXNSR0IB2cksfwAAADxQTFRFAAAAhYWVh4eTh4ePgICPh4qSh4qTiYuSiIqUiIyUiIqTiYmUh4mTiIuUh4uTiYuUiYmTiIqTiIyVioqPJcQc3wAAABR0Uk5TADBAIBBgkHCwn5BwgL9AcFCvnzCuB86uAAAAOElEQVR4nJ3H0RWAIAwDwJBSVKCocf9d5TECf3dAIi2TBLz4cV7utaHPRgCj7/J+kONdtCJ9Q5L9flgCyIWgo/wAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#img2",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause1);
export default __webpack_public_path__ + "static/media/pause1.005d2bc6baccaa2f8373f2df48085873.svg";
export { ForwardRef as ReactComponent };